<template>
  <div>
    <Spinner ref="spinner" :block="true"/>
    <div class="container-fluid" v-if="occurrence">
      <div class="form-group">
        <router-link :to="{ name: 'occurrences' }" class="btn btn-outline-info mr-2">
          <i class="icon-arrow-left"></i> Voltar
        </router-link>
        <button type="button" class="btn btn-success" @click="finalize(occurrence)" :disabled="occurrence.completedAt">
          <span v-if="occurrence.completedAt">Ocorrência finalizada</span>
          <span v-else>Finalizar ocorrência</span>
        </button>
      </div>
      <div class="form-group">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-lg-6 col-md-6">
                  {{ occurrence.seller.personName }}<br>
                <small class="text-secondary">{{ occurrence.seller.personTaxDocument }}</small><br>
                <small class="text-secondary">Data cadastro: {{ occurrence.seller.accountCreatedAt | date }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-3 pb-3">
          <div class="card h-100">
            <div class="card-body text-center">
              <p class="text-secondary">
                Risco do lojista
              </p>
              <SellerRiskScore :fraudRisk="occurrence.seller.fraudRisk" />
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 pb-3">
          <div class="card h-100">
            <div class="card-body text-center">
              <p class="text-secondary">
                Ocorrências do lojista
              </p>
              <span class="font-16" v-if="occurrenceList">
                {{ occurrenceList.count }}
              </span>
              <Spinner :small="true" v-else />
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 pb-3">
          <div class="card h-100">
            <div class="card-body text-center">
              <p class="text-secondary">
                Risco da ocorrência
              </p>
              <OccurrenceSuspiciousScore :occurrence="occurrence" />
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 pb-3">
          <div class="card h-100">
            <div class="card-body text-center">
              <p class="text-secondary">
                Casos detectados
              </p>
              <span class="font-16">
                {{ occurrence.detectedCases }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 pb-3">
          <div class="card h-100">
            <div class="card-body text-center">
              <p class="text-secondary">
                Chargeback
              </p>
              <span class="font-12">
                <i class="fa fa-circle font-sm" :class="getChargeBackColor(getChargeBack)"></i>&nbsp;
                {{ getChargeBack }} - {{ getDescriptionChargeBack(getChargeBack) }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 pb-3">
          <div class="card h-100">
            <div class="card-body text-center">
              <p class="text-secondary">
                Volume Contestado
              </p>
              <span class="font-14">
                {{ getAmountContested }}
              </span><br>
              <span class="font-12">
                Quantidade: {{ quantityContested }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 pb-3">
          <div class="card h-100">
            <div class="card-body text-center">
              <p class="text-secondary">
                Ticket Médio
              </p>
              <span class="font-16">
                {{ getTicketAvg }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <h5 class="pt-3">
          Atividades suspeitas
        </h5>
        <div class="card" v-for="suspiciousActivity in occurrence.suspiciousActivities" :key="suspiciousActivity.type">
          <div class="card-body p-3">
            <div class="row">
              <div class="col">
                <a href="#" data-toggle="collapse" :data-target="`#type-${suspiciousActivity.type}`" @click="listTransactions(suspiciousActivity)">
                  <SuspiciousActivityName :type="suspiciousActivity.type"/>
                </a>
                <br>
                <small class="text-secondary">
                  {{ suspiciousActivity.detectedCases }} {{ suspiciousActivity.detectedCases === 1 ? 'caso detectado' : 'casos detectados' }}&nbsp;
                  ({{ suspiciousActivity.transactionCount }} {{ suspiciousActivity.transactionCount === 1 ? 'transação' : 'transações' }})
                </small>
              </div>
              <div class="col-auto">
                <button type="button" class="btn" :class="changeColor(suspiciousActivity.trustedType)" @click="ignoreType(occurrence, suspiciousActivity.type)" :disabled="suspiciousActivity.trustedType">
                  <span>Ignorar tipo de ocorrência para lojista</span>
                </button>
              </div>
            </div>
            <div :id="`type-${suspiciousActivity.type}`" class="collapse">
              <hr>
              <SuspiciousActivityTransactions :ref="suspiciousActivity.type" :occurrence="occurrence" />
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <h5 class="pt-3">
          Ocorrências finalizadas
        </h5>
        <div v-if="occurrenceList">
          <div class="card mb-1" v-if="!occurrenceList">
            <div class="card-body">
              Lojista sem ocorrências anteriores.
            </div>
          </div>
          <div class="card mb-1" v-for="occurrence in occurrenceList.occurrences" :key="occurrence.id">
            <div class="card-body">
              <div class="mb-4">
                Iniciada em {{ occurrence.createdAt | datetime }}<br>
              </div>
              <ul>
                <li v-for="(suspiciousActivity, index) in occurrence.suspiciousActivities" :key="index">
                  <SuspiciousActivityName :type="suspiciousActivity.type"/><br>
                  <small class="text-secondary">
                    {{ occurrence.detectedCases }} {{ occurrence.detectedCases === 1 ? 'caso detectado' : 'casos detectados' }}
                  </small>
                  <small class="text-secondary">
                    <span v-if="occurrence.note"> / ( {{ occurrence.note }} )</span>
                  </small>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card mb-1" v-else>
          <div class="card-body text-center">
            <Spinner />
            <div>Pesquisando ocorrências finalizadas...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OccurrenceSuspiciousScore from './OccurrenceSuspiciousScore'
import SuspiciousActivityTransactions from './SuspiciousActivityTransactions'
import SuspiciousActivityName from './SuspiciousActivityName'
import OccurrenceError from '@/errors/OccurrenceError'
import SellerRiskScore from './SellerRiskScore'

export default {
  name: 'OccurrenceList',
  data () {
    return {
      occurrence: null,
      occurrenceList: null,
      quantityApproved: 0,
      quantityContested: 0,
      amountContested: 0,
      amountApproved: 0
    }
  },
  async mounted () {
    await this.find()
  },
  methods: {
    changeColor (parameter) {
      return parameter === true ? 'btn-secondary' : 'btn-success'
    },
    async find () {
      this.$refs.spinner.show('Pesquisando ocorrência...')
      this.occurrence = await this.$api.occurrences.find(this.$route.params.id)
      this.$refs.spinner.hide()

      this.listOccurrences()
      this.getQuantityApproved('approved')
      this.getQuantityContested('contested')
    },
    async listOccurrences () {
      this.occurrenceList = await this.$api.occurrences.list({
        sellerId: this.occurrence.seller.id,
        completed: true
      })
    },
    async getQuantityApproved (status) {
      var list = await this.$api.cardTransactions.list({
        taxDocument: this.occurrence.seller.personTaxDocument,
        status: status
      })

      this.quantityApproved = list.count
      this.amountApproved = list.amount
    },
    async getQuantityContested (status) {
      var list = await this.$api.cardTransactions.list({
        taxDocument: this.occurrence.seller.personTaxDocument,
        status: status
      })

      this.quantityContested = list.count
      this.amountContested = list.amount
    },
    listTransactions (suspiciousActivity) {
      if (!suspiciousActivity.opened) {
        let suspiciousType = suspiciousActivity.type
        this.$refs[suspiciousType][0].search(suspiciousType)
      }
      suspiciousActivity.opened = !suspiciousActivity.opened
    },
    async finalize (occurrence) {
      this.$swal({
        title: 'Finalizar a ocorrência',
        input: 'textarea',
        inputPlaceholder: 'Motivo da finalização',
        inputAttributes: {
          autocapitalize: 'off'
        },
        confirmButtonText: 'Sinalizar fraude',
        confirmButtonColor: '#FFFF',
        showLoaderOnConfirm: true,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Finalizar ocorrência',
        preConfirm: (note) => {
          if (!note || note.length === 0) {
            this.$swal.showValidationError('O motivo é obrigatório!')
          } else {
            this.note = note
          }
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(async (res) => {
        if (res.dismiss === 'overlay' || res.dismiss === 'close' || res.dismiss === 'esc') {
          this.$swal.isLoading()
        } else if (res.dismiss === 'cancel') {
          this.$refs.spinner.show('Finalizando ocorrência...')
          let result = await this.$api.occurrences.finalize(occurrence, this.note, false)
          if (result.error) {
            const modelError = new OccurrenceError(result)
            const error = modelError.getMessage()
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text: error
            })
            this.$refs.spinner.hide()
          } else {
            this.isDisabled = true
            this.$swal(
              'Pronto!',
              'A ocorrência foi finalizada!',
              'success'
            )
            await this.find()
            this.$refs.spinner.hide()
          }
        } else {
          this.$refs.spinner.show('Finalizando ocorrência...')
          let result = await this.$api.occurrences.finalize(occurrence, this.note, true)
          if (result.error) {
            const modelError = new OccurrenceError(result)
            const error = modelError.getMessage()
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text: error
            })
            this.$refs.spinner.hide()
          } else {
            this.isDisabled = true
            this.$swal(
              'Pronto!',
              'A ocorrência foi finalizada!',
              'success'
            )
            await this.find()
            this.$refs.spinner.hide()
          }
        }
      })
    },
    async ignoreType (occurrence, occurrenceType) {
      this.$swal({
        title: 'Ignorar tipo de ocorrência',
        text: 'Ao ignorar um tipo de ocorrência para um determinado lojista, esse tipo de ocorrência não será mais detectado, tem certeza que deseja continuar?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.value) {
          this.$refs.spinner.show('Ignorando tipo de ocorrência...')
          let result = await this.$api.occurrences.ignoreType(occurrence.id, occurrenceType, occurrence.seller.id)
          if (result.error) {
            const modelError = new OccurrenceError(result)
            const error = modelError.getMessage()
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text: error
            })
            this.$refs.spinner.hide()
          } else {
            this.isDisabled = true
            this.$swal(
              'Pronto!',
              'A partir de agora esses tipos de ocorrência serão ignorados para esse lojista!',
              'Ok!'
            )
            await this.find()
            this.$refs.spinner.hide()
          }
        }
      })
    },
    getChargeBackColor (level) {
      if (level > 3) return 'text-black'

      switch (true) {
        case level <= 0.6: return 'text-success'
        case level >= 0.7 && level <= 0.9: return 'text-yellow'
        case level >= 1 && level <= 3: return 'text-danger'
      }
    },
    getDescriptionChargeBack (level) {
      if (level > 3) return 'Muito Alto'

      switch (true) {
        case level <= 0.6: return 'Baixo'
        case level >= 0.7 && level <= 0.9: return 'Médio'
        case level >= 1 && level <= 3: return 'Alto'
      }
    }
  },
  computed: {
    getChargeBack () {
      var value = 100
      if (this.quantityApproved > 0) {
        value = ((this.quantityContested / this.quantityApproved) * 100).toFixed(2)
      }

      return value
    },
    getTicketAvg () {
      var operation = this.amountApproved / this.quantityApproved
      var value = (operation >= 0 ? operation : 0).toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      return 'R$ ' + value
    },
    getAmountContested () {
      return 'R$ ' + this.amountContested.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  components: {
    OccurrenceSuspiciousScore,
    SuspiciousActivityTransactions,
    SuspiciousActivityName,
    SellerRiskScore
  }
}
</script>
